<template>
  <section id="testimonial" class="n2-seccion" v-if="NOTARIA?.Theme?.Home?.Testimonios?.Mostrar && lista.length">
    <div class="n2-contenedor">
      <div class="n2-citas">
        <figure v-for="(t, i) in lista" :key="t.id ?? i" class="n2-cita n2-aparece">
          <div class="n2-estrellas" :aria-label="(t.Estrellas || 5) + ' / 5'">
            <v-icon v-for="n in (Number(t.Estrellas) || 5)" :key="n" size="18">{{ NOTARIA.Theme.Home.Testimonios.Icon || 'mdi-star' }}</v-icon>
          </div>
          <blockquote>“{{ textoPlano(t.Descripcion) }}”</blockquote>
          <figcaption>
            <img v-if="t.Imagen" :src="imagenIDtoSRC(t.Imagen)" :alt="t.Nombre" loading="lazy" />
            <span>{{ t.Nombre }}</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { textoPlano } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC } = useUtils()
// Panel: Testimonios (y su interruptor en Inicio)
const lista = computed(() => NOTARIA.value?.Testimonios ?? [])
</script>
